
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { CheckCircle2, XCircle } from 'lucide-react';

interface Permission {
  id: string;
  name: string;
  description: string;
  admin: boolean;
  hr: boolean;
  finance: boolean;
  employee: boolean;
}

// Mock permissions data
const permissions: Permission[] = [
  {
    id: 'perm-1',
    name: 'View Dashboard',
    description: 'Access to view the main dashboard',
    admin: true,
    hr: true,
    finance: true,
    employee: true
  },
  {
    id: 'perm-2',
    name: 'Manage Employees',
    description: 'Create, update, and delete employee records',
    admin: true,
    hr: true,
    finance: false,
    employee: false
  },
  {
    id: 'perm-3',
    name: 'Process Payroll',
    description: 'Generate and approve payslips',
    admin: true,
    hr: false,
    finance: true,
    employee: false
  },
  {
    id: 'perm-4',
    name: 'Approve Loans',
    description: 'Review and approve loan requests',
    admin: true,
    hr: true,
    finance: true,
    employee: false
  },
  {
    id: 'perm-5',
    name: 'Manage Departments',
    description: 'Create and modify department structure',
    admin: true,
    hr: true,
    finance: false,
    employee: false
  },
  {
    id: 'perm-6',
    name: 'View Own Payslips',
    description: 'Access to view personal payslips',
    admin: true,
    hr: true,
    finance: true,
    employee: true
  },
  {
    id: 'perm-7',
    name: 'System Configuration',
    description: 'Configure system-wide settings',
    admin: true,
    hr: false,
    finance: false,
    employee: false
  }
];

const Permissions = () => {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex justify-between">
          <h1 className="text-2xl font-bold tracking-tight">System Permissions</h1>
        </div>
        
        <Card>
          <CardHeader>
            <CardTitle>Role-Based Access Control</CardTitle>
            <CardDescription>
              Defines what actions different user roles can perform in the system
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Permission</TableHead>
                  <TableHead>Description</TableHead>
                  <TableHead>Admin</TableHead>
                  <TableHead>HR</TableHead>
                  <TableHead>Finance</TableHead>
                  <TableHead>Employee</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {permissions.map(permission => (
                  <TableRow key={permission.id}>
                    <TableCell className="font-medium">{permission.name}</TableCell>
                    <TableCell>{permission.description}</TableCell>
                    <TableCell>{permission.admin ? 
                      <CheckCircle2 className="h-5 w-5 text-green-500" /> : 
                      <XCircle className="h-5 w-5 text-red-500" />}
                    </TableCell>
                    <TableCell>{permission.hr ? 
                      <CheckCircle2 className="h-5 w-5 text-green-500" /> : 
                      <XCircle className="h-5 w-5 text-red-500" />}
                    </TableCell>
                    <TableCell>{permission.finance ? 
                      <CheckCircle2 className="h-5 w-5 text-green-500" /> : 
                      <XCircle className="h-5 w-5 text-red-500" />}
                    </TableCell>
                    <TableCell>{permission.employee ? 
                      <CheckCircle2 className="h-5 w-5 text-green-500" /> : 
                      <XCircle className="h-5 w-5 text-red-500" />}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Permissions;
